import React from 'react';
import './Video.scss';
import SvgIconLoader, {
  SVG_ICON_KIND,
  SEGMENT,
  COLOR,
  ICONS_ID,
} from '@bit/gerenciatd.unifiedicons.svg-icon-loader';
import Modal from '@bit/gerenciatd.unifiedcomponents.modal';
import CustomLink from '@bit/gerenciatd.unifiedcomponents.custom-link';

const handleModal = () => {
  Modal.hide();
};

export const COMPONENT_NAME = 'Video';

const Video = ({ urlVideo }) => {
  return (
    <div className="Video">
      <CustomLink
        taggingInfo={{
          componentContent: 'close-video',
          componentProduct: '',
          componentVariation: 'all',
          componentName: COMPONENT_NAME,
        }}
        onClick={handleModal}
      >
        <span>
          <SvgIconLoader
            kind={SVG_ICON_KIND.LIGHT}
            segment={SEGMENT.EMP}
            backgroundColor={COLOR.TRANSPARENT}
            size={30}
            id={ICONS_ID.Cerrar}
            color={COLOR.WHITE}
            className="Video__close"
            onClick={handleModal}
          />
        </span>
      </CustomLink>
      <iframe
        src={urlVideo}
        frameBorder="1"
        allowFullScreen
        title="video"
        className="Video__wrapper"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      />
    </div>
  );
};

export default Video;
